import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SiteService } from "../_services/SiteService";

export const fetchSitesByOrganization = createAsyncThunk(
    "site/fetchByOrganization",
    async ({ organization_id, page, limit }, { rejectWithValue }) => {
        const res = await SiteService.getSitesByOrganization(organization_id, {
            page,
            limit,
        });

        if (!res.status) {
            return rejectWithValue(res.message);
        }

        return res.data;
    }
);

const siteSlice = createSlice({
    name: "site",
    initialState: {
        list: [],
        loading: false,
        error: null,
        page: 1,
        limit: 20,
        total: 0,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ⏳ Pending
            .addCase(fetchSitesByOrganization.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            // ✅ Success
            .addCase(fetchSitesByOrganization.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload.data || action.payload;
                state.total = action.payload.total || 0;
            })

            // ❌ Error
            .addCase(fetchSitesByOrganization.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default siteSlice.reducer;
